exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bookings-wrapper{background:#234974!important}.bookings-content{background:#12253c!important}.bookings-widget-card{border:0!important}.booking-status{color:#5f954b;text-transform:uppercase;padding:5px 10px;border:1px solid #5f954b;background:transparent}.bookings-widget-card{background:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2866412b","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/stages/Widgets/Tabs/Bookings.vue
// module id = GAqW
// module chunks = 1 2